import './style.css';
import { jsx as s } from "react/jsx-runtime";
import { useId as B, useState as C, useEffect as T } from "react";
import { c as d } from "../../__shared__/index.js";
import w from "../../containers/UnmanagedDom/UnmanagedDom.js";
const A = "_large_8gglm_5", p = "_addToCart_8gglm_10", v = "_loading_8gglm_15", N = "_mouseUser_8gglm_59", P = "_forcePosition_8gglm_155", e = {
  large: A,
  addToCart: p,
  loading: v,
  mouseUser: N,
  forcePosition: P
};
function S({
  className: o,
  productId: t,
  namespace: n,
  size: a = "large",
  loadingLabel: c = "Loading",
  quantityPickerPosition: l
}) {
  const g = B(), [u, m] = C(!1), i = a === "small" ? "small" : "large", r = [
    n,
    "a2c",
    t == null ? void 0 : t.replace(/(\s|\W)/g, "-"),
    g
  ].join("-");
  T(() => {
    (async () => (await y(r, t, i), m(!0)))();
  }, [r]);
  const _ = i === "large" ? "AddToBagButtonLarge" : "AddToBagButtonSmall", f = l ? d(e.forcePosition, l) : void 0;
  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
    /* @__PURE__ */ s(
      "div",
      {
        className: d(
          o,
          i === "large" ? e.large : void 0,
          f
        ),
        onClick: h,
        children: /* @__PURE__ */ s(w, { id: r, className: e.addToCart, children: u ? null : /* @__PURE__ */ s(
          "button",
          {
            className: d(
              "AddToBagButton",
              _,
              e.loading
            ),
            type: "button",
            disabled: !0,
            children: c
          }
        ) })
      }
    )
  );
}
function j(o) {
  return o.__isAddToCard__ ?? !1;
}
const h = (o) => {
  o.nativeEvent.__isAddToCard__ = !0;
};
async function y(o, t, n) {
  if (window.napi) {
    try {
      await window.napi.getConfig();
    } catch (a) {
      console.error("NAPI getConfig error", a);
      return;
    }
    window.ui ?? (window.ui = []), window.ui.push({
      id: o,
      module: "AddToBagButton",
      configuration: { props: { productId: t, buttonSize: n } },
      ecommerceData: { activated: !0 }
    });
  }
}
export {
  S as default,
  j as isAddToCartEvent
};
//# sourceMappingURL=AddToCartButton.js.map
